<template>
  <InAppAnnouncement
    v-if="visibleAnnouncements.length"
    :announcements="visibleAnnouncements"
    :got-it-fn="markAnnouncementAsSeen"
    :open-release-updates-fn="onOpenReleaseUpdates"
  />
</template>

<script>
import InAppAnnouncement from '@/modules/announcement/components/stateful/InAppAnnouncement.vue';
import { HasUnseenAnnouncementsMixin } from '@/modules/announcement/mixins/HasUnseenAnnouncementsMixin';
import AnnouncementService from '@/modules/announcement/services/AnnouncementService';
import { ReleaseUpdatesRoute } from '@/modules/resourcecenter/constants/ReleaseUpdatesRoute';
import { AnnouncementOpenReleaseUpdatesClicked } from '@/modules/announcement/models/segmentevents/AnnouncementOpenReleaseUpdatesClicked';
import { AnnouncementGotItClicked } from '@/modules/announcement/models/segmentevents/AnnouncementGotItClicked';
import { AnnouncementDisplayed } from '@/modules/announcement/models/segmentevents/AnnouncementDisplayed';

export default {
  compatConfig: {
    COMPONENT_V_MODEL: true
  },
  name: 'InAppAnnouncementTrigger',
  mixins: [HasUnseenAnnouncementsMixin],
  components: { InAppAnnouncement },
  computed: {
    visibleAnnouncements() {
      return this.unseenAnnouncements.filter((announcement) =>
        this.$route.path.includes(announcement.urlScope)
      );
    }
  },
  methods: {
    async onOpenReleaseUpdates() {
      this.markAnnouncementAsSeen();
      this.visibleAnnouncements.forEach((announcement) => {
        AnnouncementOpenReleaseUpdatesClicked.dispatch(announcement.id);
      });
      await this.$router.push({ name: ReleaseUpdatesRoute.RELEASE_UPDATES });
    },
    markAnnouncementAsSeen() {
      const ids = this.visibleAnnouncements.map((announcement) => announcement.id);
      AnnouncementService.markAsSeen(ids);
      this.visibleAnnouncements.forEach((announcement) => {
        AnnouncementGotItClicked.dispatch(announcement.id);
      });
    }
  },
  mounted() {
    this.visibleAnnouncements.forEach((announcement) => {
      AnnouncementDisplayed.dispatch(announcement.id);
    });
  }
};
</script>
